<template>
  <div>
    <div 
      v-if="isReportEnabled('amaSeriesResults')" 
      :class="['reportCard', seriesActive]" 
      @click="getSeries()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.series-ama-report") }}</div>
      <div class="cardDesc"></div>
    </div>
    <div 
      v-if="isReportEnabled('awards')" 
      :class="['reportCard', seriesAwardActive]" 
      @click="getSeriesAward()"
    >
      <div class="cardImg">
        <i class="fal fa-table"></i>
      </div>
      <div class="cardTitle">{{ $tc("page.report.series-award-report") }}</div>
      <div class="cardDesc"></div>
    </div>

    <div class="v-spacer"></div>
    <v-card v-if="displayTable" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.series-ama-report") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>


          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete 
                v-model="seriesSelected" 
                :items="seriesItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-select-series')" 
                :multiple="false" :outlined="true" dense
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <v-btn v-if="tabulatorData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsPDF()">
                  {{ $tc("page.report.label-pdf-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="tabulatorData.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsCSV()">
                  {{ $tc("page.report.label-csv-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                </v-btn>
                <v-btn color="blue-grey" class="ma-1 white--text" @click="getReport()">
                  {{ $tc("page.report.label-load-report-btn") }}
                  <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <VueTabulator ref="tabulator" v-model="tabulatorData" :options="tabulatorOptions" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card v-if="displayAwardTable" class="mx-auto" width="100%">
      <v-card-title>{{ $tc("page.report.award-report") }}</v-card-title>

      <v-card-text class="text--primary">
        <v-container fluid>


          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="6">
              <v-autocomplete  
                v-model="seriesSelected" 
                :items="seriesItems" 
                item-text="text" 
                item-value="id" 
                :label="$tc('page.report.label-select-series')" 
                :multiple="false" :outlined="true" dense>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <v-btn v-if="tabulatorDataAwards.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsPDF()">
                  {{ $tc("page.report.label-pdf-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-pdf</v-icon>
                </v-btn>
                <v-btn v-if="tabulatorDataAwards.length > 0" color="blue-grey" class="ma-2 white--text" @click="downloadAsCSV()">
                  {{ $tc("page.report.label-csv-btn") }}
                  <v-icon rigth dark class="pdl8">fa-file-csv</v-icon>
                </v-btn>
                <v-btn color="blue-grey" class="ma-1 white--text" @click="getReportAwards()">
                  {{ $tc("page.report.label-load-report-btn") }}
                  <v-icon rigth dark class="pdl8">fa-sync</v-icon>
                </v-btn>
              </v-card>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col class="d-flex" cols="12" sm="12">
              <v-card>
                <VueTabulator ref="tabulatorAwards" v-model="tabulatorDataAwards" :options="tabulatorOptionsAwards" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from 'vuex';

export default {
  mixins: [apiCalls],
  data() {
    return {
      seriesSelected: [],
      raceRegistrationSelected: [],
      seriesItems: [],
      seriesActive: "",
      search: "",
      displayTable: false,
      series: [],
      tabulatorData: [],
      seriesAwardActive: "",
      displayAwardTable: false,
      tabulatorDataAwards: [],
      raceColumns: [],
      seriesDisplayOptions: {
        showOverall: true,
        showClass: true,
        showGroup: true,
        showBrand: true
      }
    };
  },
  computed: {
    ...mapState({
      reportConfig: (state) => state.reports.reportConfig
    }),
    races_Registration: function () {
      let arrayItems = [];

      arrayItems.push({
        id: 0,
        text: this.$t("page.report.label-series"),
      });
      arrayItems.push({
        id: 1,
        text: this.$t("page.report.series-ama-report"),
      });

      return arrayItems;
    }, 
    tabulatorOptions() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        downloadConfig: {
          columnGroups: false
        },
        layoutColumnsOnNewData: true,
        columns: [
          {
            title: this.$t("page.report.series-ama-columns.col-firstname"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-lastname"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-birthday"),
            field: "birthday",
            sorter: "alphanum",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-ama"),
            field: "memberId",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 90,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-classname"),
            field: "className",
            sorter: "alphanum",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("className", "ama"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-classpos"),
            field: "classPosition",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-overall"),
            field: "overall",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-brand"),
            field: "brand",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("brand", "ama"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-groupname"),
            field: "groupName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-grouppos"),
            field: "groupPosition",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-email"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 150,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-address"),
            field: "address",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 130,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("city", "ama"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("state", "ama"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-country"),
            field: "country",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-zip"),
            field: "zip",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 60,
            formatter: "textarea"
          }
        ].filter((column) => this.shouldShowSeriesColumn(column.field)).concat(this.raceColumns)
      };
    },
    tabulatorOptionsAwards() {
      return {
        layout: "fitColumns",
        placeholder: this.$t("common.no_data_set"),
        height: 500,
        printAsHtml: true,
        downloadRowRange: "all",
        layoutColumnsOnNewData: true,
        columns: [
          {
            title: this.$t("page.report.series-ama-columns.col-firstname"),
            field: "firstName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-lastname"),
            field: "lastName",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-birthday"),
            field: "birthday",
            sorter: "alphanum",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-ama"),
            field: "memberId",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 90,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-award-columns.col-classgroupname"),
            field: "classGroupName",
            sorter: "alphanum",
            headerFilter: "select",
            headerFilterFunc: "in",
            headerFilterParams: { values: true, sortValuesList: "asc", multiselect: true },
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-award-columns.col-award-type"),
            field: "awardType",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-award-columns.col-position"),
            field: "position",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-award-columns.col-phone"),
            field: "phone",
            sorter: "string",
            minWidth: 100,
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-award-columns.col-total-points"),
            field: "totalPoints",
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-brand"),
            field: "brand",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("brand", "award"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-email"),
            field: "emailAddress",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 150,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-address"),
            field: "address",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 130,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-city"),
            field: "city",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("city", "award"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-state"),
            field: "state",
            sorter: "string",
            headerFilter: "select",
            ...this.getCaseInsensitiveMultiselectFilter("state", "award"),
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-country"),
            field: "country",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 100,
            formatter: "textarea"
          },
          {
            title: this.$t("page.report.series-ama-columns.col-zip"),
            field: "zip",
            sorter: "string",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical:'flip',
            minWidth: 60,
            formatter: "textarea"
          }
        ]
      };
    }
  },
  methods: {
    normalizeDisplayOption(value, defaultValue = true) {
      if (value === undefined || value === null) {
        return defaultValue;
      }

      return value === true || value === 1 || value === "1" || value === "true";
    },
    normalizeDisplayOptions(displayOptions = {}) {
      return {
        showOverall: this.normalizeDisplayOption(displayOptions.showOverall),
        showClass: this.normalizeDisplayOption(displayOptions.showClass),
        showGroup: this.normalizeDisplayOption(displayOptions.showGroup),
        showBrand: this.normalizeDisplayOption(displayOptions.showBrand)
      };
    },
    shouldShowSeriesColumn(field) {
      const displayOptionByField = {
        classPosition: "showClass",
        overall: "showOverall",
        brand: "showBrand",
        groupPosition: "showGroup"
      };
      const displayOption = displayOptionByField[field];

      return !displayOption || this.seriesDisplayOptions[displayOption];
    },
    getEnabledRacePointTypes(displayOptions = this.seriesDisplayOptions) {
      return [
        {
          key: "overall",
          option: "showOverall",
          positionField: "overallPosition",
          pointsField: "overallPoints",
          positionTitleKey: "page.report.series-ama-columns.col-overall",
          pointsTitleKey: "page.report.series-ama-columns.col-overall-points"
        },
        {
          key: "class",
          option: "showClass",
          positionField: "classPosition",
          pointsField: "classPoints",
          positionTitleKey: "page.report.series-ama-columns.col-classpos",
          pointsTitleKey: "page.report.series-ama-columns.col-class-points"
        },
        {
          key: "group",
          option: "showGroup",
          positionField: "groupPosition",
          pointsField: "groupPoints",
          positionTitleKey: "page.report.series-ama-columns.col-grouppos",
          pointsTitleKey: "page.report.series-ama-columns.col-group-points"
        }
      ].filter((pointType) => displayOptions[pointType.option]);
    },
    mapSeriesReportRows(results, races, pointTypes) {
      return (results || []).map((result) => {
        const mappedData = {
          ...result
        };

        (races || []).forEach((raceFilter) => {
          const participantRace = result.races?.find(
            (race) => String(race.raceId) === String(raceFilter.id)
          );

          pointTypes.forEach((pointType) => {
            const positionKey = `race${raceFilter.id}_${pointType.key}Position`;
            const pointsKey = `race${raceFilter.id}_${pointType.key}Points`;

            mappedData[positionKey] = participantRace?.[pointType.positionField] ?? "";
            mappedData[pointsKey] = participantRace?.[pointType.pointsField] ?? "";
          });
        });

        return mappedData;
      });
    },
    buildRaceColumns(races, pointTypes) {
      if (!pointTypes.length) {
        return [];
      }

      return (races || []).map((race) => ({
        title: `${race.raceOrder}`,
        columns: pointTypes.flatMap((pointType) => [
          {
            title: this.$t(pointType.positionTitleKey),
            titleDownload: `${race.raceOrder} - ${this.$t(pointType.positionTitleKey)}`,
            field: `race${race.id}_${pointType.key}Position`,
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical: "flip",
            sorterParams: {
              alignEmptyValues: "bottom"
            }
          },
          {
            title: this.$t(pointType.pointsTitleKey),
            titleDownload: `${race.raceOrder} - ${this.$t(pointType.pointsTitleKey)}`,
            field: `race${race.id}_${pointType.key}Points`,
            sorter: "number",
            headerFilter: "input",
            headerFilterPlaceholder: " ",
            headerVertical: "flip",
            sorterParams: {
              alignEmptyValues: "bottom"
            }
          }
        ])
      }));
    },
    normalizeCaseValue(value) {
      return (value ?? "")
        .toString()
        .normalize("NFKC")
        .replace(/[\u200B-\u200D\uFEFF]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },
    getCaseInsensitiveMultiselectFilter(field, source = "ama") {
      return {
        headerFilterFunc: (headerValue, rowValue) => {
          const selectedValues = Array.isArray(headerValue) ? headerValue : (headerValue ? [headerValue] : []);
          if (!selectedValues.length) return true;
          const normalizedRowValue = this.normalizeCaseValue(rowValue);
          return selectedValues.map((value) => this.normalizeCaseValue(value)).includes(normalizedRowValue);
        },
        headerFilterParams: {
          values: () => {
            const tableData = source === "award" ? this.tabulatorDataAwards : this.tabulatorData;
            const unique = new Set();
            (tableData || []).forEach((row) => {
              const normalized = this.normalizeCaseValue(row?.[field]);
              if (normalized) unique.add(normalized);
            });
            return Array.from(unique).sort();
          },
          sortValuesList: "asc",
          multiselect: true
        }
      };
    },
    refresh(type = "ama") {
      switch(type) {
        case "ama":
          this.getReport();
        break;
        case "award": 
          this.getReportAwards();
        break;
      }
    },
    async loadSeries() {
      const response = await this.api("get", "/api/v1/promoter/series");

      let arrayItems = [];
      const parent = this;
      response.forEach(function (e) {
        if(parent.displayTable || e.showAwards) {
          arrayItems.push({
            id: e.id,
            text: e.seriesName,
          });
        }
      });

      this.seriesItems = arrayItems;
      this.events = response.map((el) => {
        return {
          id: el.id,
          text: `${el.seriesName}`
        };
      });
    },
    getSeries() {
      this.seriesAwardActive = ""; this.displayAwardTable = false; this.seriesSelected = null;
      if(this.seriesActive == "active"){
        this.seriesActive = "";
        this.displayTable = false;
      } else {
        this.seriesActive = "active";
        this.displayTable = true;
      }
      this.loadSeries();
    },
    getSeriesAward() {
      this.seriesActive = ""; this.displayTable = false; this.seriesSelected = null;
      if(this.seriesAwardActive == "active"){
        this.seriesAwardActive = "";
        this.displayAwardTable = false;
      } else {
        this.seriesAwardActive = "active";
        this.displayAwardTable = true;
      }
      this.loadSeries();
    },
    async getReport() {
      this.tabulatorData = [];
      this.raceColumns = [];
      if (!this.seriesSelected) {
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-series-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      try {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      tabulatorInstance.clearHeaderFilter();

        const response = await this.api("get", `/api/v1/promoter/reports/series/ama/${this.seriesSelected}`);
        const races = response?.filters?.races || [];
        this.seriesDisplayOptions = this.normalizeDisplayOptions(response?.filters?.displayOptions);
        const pointTypes = this.getEnabledRacePointTypes(this.seriesDisplayOptions);

        this.tabulatorData = this.mapSeriesReportRows(response?.results, races, pointTypes);
        this.raceColumns = this.buildRaceColumns(races, pointTypes);
      } catch {
        this.tabulatorData = [];
        this.raceColumns = [];
      }
    },
    async getReportAwards() {
      this.tabulatorDataAwards = [];
      if (!this.seriesSelected) {
        this.$store.commit('reports/SET_MSG_ALERT', this.$t('page.report.notifications.select-series-required'));
        this.$store.commit('reports/SET_SHOW_ALERT', true);
        return;
      }

      try {
      const tabulatorInstance = this.$refs.tabulatorAwards.getInstance();
      tabulatorInstance.clearHeaderFilter();

        const response = await this.api("get", `/api/v1/promoter/reports/series/award/${this.seriesSelected}`);
        this.tabulatorDataAwards = response?.results || [];
      } catch {
        this.tabulatorDataAwards = [];
      }
    },
    downloadAsPDF() {
      const tabulatorInstance = this.displayTable ? this.$refs.tabulator.getInstance() : this.$refs.tabulatorAwards.getInstance();
      tabulatorInstance.downloadToTab("pdf","data.csv", {}, "active");
    },
    downloadAsCSV() {
      const tabulatorInstance = this.displayTable ? this.$refs.tabulator.getInstance() : this.$refs.tabulatorAwards.getInstance();
      tabulatorInstance.download("csv", "data.csv", {}, "active");
    },
    isReportEnabled(reportId) {
      return this.reportConfig.series.reports.find(report => report.name === reportId && report.isEnabled) || false;
    }
  },
  created() {},
  mounted() {}, 
  watch: {
    tabulatorOptions() {
      const tabulatorInstance = this.$refs.tabulator.getInstance();
      if(tabulatorInstance) {
        tabulatorInstance.redraw(true)
      }
    }
  }
};
</script>

<style scoped lang="scss">
.reportCard.active {
  background-color: var(--v-primary-base);
  color: var(--v-lighten-base);
  cursor: auto;
}

.reportCard {
  border: 1px var(--v-primary-darken2) solid;
  padding: 5px 0;
  cursor: pointer;
}

.reportCard .cardImg {
  float: left;
  font-size: 45px;
  width: 50px;
  height: 50px;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard > div > i {
  vertical-align: top;
}

.fal,
.far {
  font-family: "Font Awesome 5 Pro";
}

.fal {
  font-weight: 300;
}

.fa,
.fab,
.fad,
.fal,
.far,
.fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.reportCard > div {
  display: inline-block;
  padding: 0 5px;
}

.reportCard .cardDesc {
  width: 80%;
}

/*.v-card__title {
  background-color: #ddd;
  color: #333;
}*/

.reportCard {
  text-align: left;
}

.pdl8 {
  padding-left: 8px;
}
</style>
